module.exports = __webpack_public_path__ + "img/phoneLogoDetailCampus.4e52c92.png";